// extracted by mini-css-extract-plugin
export default {"top-bar-icons":"NavigationPane_top-bar-icons__Tfxd3","menu-item":"NavigationPane_menu-item__x98tv","menu-items":"NavigationPane_menu-items__opNQV"};